<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;">
<!--    <Title :title="route"></Title>-->

    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px;" shadow="never">
      <el-form  label-position="left" label-width="150px">
        <el-divider content-position="left">申请人信息</el-divider>

        <el-form-item label="申请人" prop="">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>

        <el-form-item label="所属部门" prop="">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>

        <el-divider content-position="left">请假信息</el-divider>
        <el-form-item prop="leaveType" label-width="150px" label="请假类型">
          <el-radio-group disabled v-model="detail.leaveType" style="cursor: not-allowed;pointer-events:none">
            <el-radio :label="1">事假</el-radio>
            <el-radio :label="2">婚嫁</el-radio>
            <el-radio :label="3">丧假</el-radio>
            <el-radio :label="4">病假</el-radio>
            <el-radio :label="5">年假</el-radio>
            <el-radio :label="6">产假</el-radio>
            <el-radio :label="7">其他</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="leaveTimes" label-width="150px" label="请假时间">
          <el-date-picker
              readonly
              v-model="detail.leaveTimes"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="leaveSubject" label-width="150px" label="请假事由">
          <el-input type="textarea" rows=5 maxlength="300" show-word-limit readonly
                    v-model="detail.leaveSubject"></el-input>
        </el-form-item>
        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>
        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>
          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>
          <el-Form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-Form-item>
        </div>

      </el-form>
    </el-card>
  </div>

</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestAuditShow} from "../../../api";
import AuditList from "../common/AuditList";
import Setp from "../common/Setp";

export default {
  components: {AuditList, Title,Setp},
  name: "LeaveDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name:'请假申请详情',
        path: ''
      },
      index: "",
      detail: {
        leaveTimes: []
      },
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      ruleForm: {
        auditOpinion: "",
      },
      user: {},
      nodes:[],
      allowAudit: false,
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {

      this.allowAudit = false

      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }
      requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      this.index = btoa(`${this.applyId}#${this.applyServiceId}#${this.applyType}`)
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            if (res.object.detail.leaveBegainTime && res.object.detail.leaveEndTime) {
              this.$set(this.detail, "leaveTimes", [
                "" + res.object.detail.leaveBegainTime + "",
                "" + res.object.detail.leaveEndTime + "",
              ]);
            }
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.user = res.object.user
            this.nodes = res.object.nodes
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  }
}
</script>

<style>

</style>
